const fallback = (phrase: string) => phrase

export function transliterateAndSlugify(phrase: string) {
  return import(
    /* webpackChunkName: "transliteration" */
    './transliteration-chunk'
  )
    .catch(() => ({ slugify: fallback }))
    .then(({ slugify }) => slugify(phrase, { allowedChars: 'a-zA-Z0-9' }))
}

export type TransliterateAndSlugify = typeof transliterateAndSlugify
